// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from 'E:/programTool/phpstudy_pro/WWW/cb_erp/cb_erp_frontend/src/models/amazon';
import model_2 from 'E:/programTool/phpstudy_pro/WWW/cb_erp/cb_erp_frontend/src/models/orders';
import model_3 from 'E:/programTool/phpstudy_pro/WWW/cb_erp/cb_erp_frontend/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: 'amazon', model: model_1 },
model_2: { namespace: 'orders', model: model_2 },
model_3: { namespace: '@@initialState', model: model_3 },
} as const
